import React from 'react';
import { translate } from '@utils/i18n';
import IssuesTypeFlags from './IssuesTypeFlags';
import AdvancedSettings from './AdvancedSettings';
const namespace = 'features.settings.ai_inspection_manager';
function GeneralSettings({ settingsData, accounts, accountTags, buildingTags }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { className: "workspace__section" },
            React.createElement("header", { className: "section__title" },
                React.createElement("h2", { className: "section__label" }, translate('issues_section_title', { namespace })),
                React.createElement("hr", { className: "section__split" })),
            React.createElement(IssuesTypeFlags, { settingsData: settingsData, accounts: accounts, accountTags: accountTags, buildingTags: buildingTags })),
        React.createElement(AdvancedSettings, null)));
}
export default GeneralSettings;
